import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiBox, FiMapPin, FiTruck } from "react-icons/fi";
import "../css/delivery.scss";
import siteConfig, { formatPrice } from "../config/siteConfig";

function Delivery() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="delivery service-page app-page-enter">
      <header className="service-page__hero">
        <div>
          <p className="eyebrow">Service / Shipping</p>
          <h1>Van atelier<br /><em>tot voordeur.</em></h1>
        </div>
        <div>
          <p>
            Dit verzendoverzicht toont de voorbeeldopties van deze winkeldemo.
            Gratis standaardlevering vanaf {formatPrice(siteConfig.freeShippingThreshold)}.
          </p>
          <a className="text-link" href="#shipping-options">Bekijk opties <FiArrowRight aria-hidden="true" /></a>
        </div>
      </header>

      <section className="service-page__facts" aria-label="Shipping summary">
        <article><span>01</span><strong>2–4 werkdagen</strong><p>Standaard in België en Nederland</p></article>
        <article><span>02</span><strong>Track &amp; trace</strong><p>Zodra je pakket het atelier verlaat</p></article>
        <article><span>03</span><strong>Gratis vanaf {formatPrice(siteConfig.freeShippingThreshold)}</strong><p>Daaronder {formatPrice(siteConfig.standardShipping)}</p></article>
      </section>

      <section className="service-page__options" id="shipping-options">
        <header><p className="eyebrow">Delivery methods</p><h2>Kies het tempo dat bij je past.</h2></header>
        <div>
          <article>
            <FiBox aria-hidden="true" /><span>Standard</span><h3>Rustig onderweg.</h3>
            <p>Levering binnen 2–4 werkdagen, inclusief track &amp; trace.</p>
            <strong>{formatPrice(siteConfig.standardShipping)} / gratis boven drempel</strong>
          </article>
          <article>
            <FiTruck aria-hidden="true" /><span>Express</span><h3>Morgen in huis.</h3>
            <p>Bestel op werkdagen vóór 13:00 voor levering op de volgende werkdag.</p>
            <strong>{formatPrice(15)}</strong>
          </article>
          <article>
            <FiMapPin aria-hidden="true" /><span>Atelier care</span><h3>Persoonlijk geholpen.</h3>
            <p>Vragen over maat of levering? Ons team kijkt met je mee vóór verzending.</p>
            <a href={`mailto:${siteConfig.contact.email}`}>Neem contact op</a>
          </article>
        </div>
      </section>

      <section className="service-page__journey">
        <div><p className="eyebrow">Your parcel journey</p><h2>Goed verpakt,<br />helder gevolgd.</h2></div>
        <ol>
          <li><span>01</span><div><h3>Order ontvangen</h3><p>Je krijgt direct een bevestiging met het overzicht.</p></div></li>
          <li><span>02</span><div><h3>Fit check &amp; packing</h3><p>We controleren de variant en verpakken zonder onnodige lagen.</p></div></li>
          <li><span>03</span><div><h3>Onderweg</h3><p>De vervoerder stuurt je een track &amp; trace-link.</p></div></li>
          <li><span>04</span><div><h3>Afgeleverd</h3><p>Pas rustig thuis. Een retour kan binnen 30 dagen worden aangemeld.</p></div></li>
        </ol>
      </section>

      <section className="service-page__table">
        <header><p className="eyebrow">Destinations</p><h2>Verzendoverzicht.</h2></header>
        <div role="table" aria-label="Shipping destinations">
          <div role="row"><span role="columnheader">Bestemming</span><span role="columnheader">Standaard</span><span role="columnheader">Levertijd</span></div>
          <div role="row"><strong role="cell">België &amp; Nederland</strong><span role="cell">{formatPrice(siteConfig.standardShipping)}</span><span role="cell">2–4 werkdagen</span></div>
          <div role="row"><strong role="cell">Luxemburg, Frankrijk, Duitsland</strong><span role="cell">{formatPrice(12)}</span><span role="cell">3–5 werkdagen</span></div>
          <div role="row"><strong role="cell">Overige EU</strong><span role="cell">{formatPrice(18)}</span><span role="cell">4–7 werkdagen</span></div>
        </div>
        <p>Lokale feestdagen en afgelegen adressen kunnen de levertijd verlengen. Eventuele invoerrechten buiten de EU zijn voor de ontvanger.</p>
      </section>

      <section className="service-page__faq">
        <header><p className="eyebrow">Questions / Answers</p><h2>Goed om te weten.</h2></header>
        <div>
          <details><summary>Kan ik mijn adres nog wijzigen?</summary><p>Mail ons zo snel mogelijk. Zolang het pakket niet is overgedragen, proberen we het adres aan te passen.</p></details>
          <details><summary>Wat als mijn pakket vertraagd is?</summary><p>Controleer eerst de track &amp; trace. Is er drie werkdagen geen update, neem dan contact met ons op.</p></details>
          <details><summary>Verzenden jullie in het weekend?</summary><p>Orders worden op werkdagen verwerkt. Sommige vervoerders bezorgen wel op zaterdag.</p></details>
          <details><summary>Is dit een echte verzendservice?</summary><p>Deze front-end is een winkel-demo; er worden geen echte orders of pakketten aangemaakt.</p></details>
        </div>
      </section>

      <section className="service-page__cta">
        <p className="eyebrow">Ready when you are</p><h2>Vind jouw perfecte paar.</h2>
        <Link className="solid-button" to="/shop" onClick={scrollTop}>Bekijk de collectie <FiArrowRight aria-hidden="true" /></Link>
      </section>
    </main>
  );
}

export default Delivery;
